// LearnCore Frontend - 应用入口文件

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/theme.css'
import ttsService from './services/ttsService'
import { registerSW } from './utils/swRegister'

// 注册Service Worker
registerSW()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// 在应用启动后尽快初始化TTS，预热语音列表
ttsService.init();
